import React from "react";
import styles from "./CircleLoaderV2.module.scss";

export interface ICircleLoaderV2Props {
  mode?: "light" | "dark";
}

export const CircleLoaderV2: React.FC<ICircleLoaderV2Props> = ({
  mode = "light",
}) => {
  let color = "currentColor";

  if (mode && mode === "light") color = "#868CA2";
  if (mode && mode === "dark") color = "#5A617C";

  return (
    <svg
      width="34"
      height="34"
      viewBox="0 0 34 34"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        opacity="0.3"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17 31C24.732 31 31 24.732 31 17C31 9.26801 24.732 3 17 3C9.26801 3 3 9.26801 3 17C3 24.732 9.26801 31 17 31Z"
        stroke={color}
        strokeWidth="6"
      />
      <path
        className={styles.animation}
        d="M17 31C24.732 31 31 24.732 31 17C31 9.26801 24.732 3 17 3C9.26801 3 3 9.26801 3 17C3 24.732 9.26801 31 17 31Z"
        stroke={color}
        strokeWidth="6"
        strokeLinecap="round"
      />
    </svg>
  );
};
